const _excluded = ["children", "iconStart", "iconEnd", "skin", "as", "disabled", "intent", "tooltipProps", "closeOnClick", "onClick"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo, useState } from 'react';
import { Menu, MenuList } from '@material-ui/core';
import { isTestMode } from "../../utils/test-mode";
import { ConditionalWrapper } from "../ConditionalWrapper";
import { useDevice } from "../Device";
import { useIntentBehavior } from "../IntentBehavior";
import { Box, Row } from "../Layout";
import { MenuItem } from "../MenuItem/MenuItem";
import { useOverlayContext } from "../OverlayContext";
import { Tooltip } from "../Tooltip";
import { useDropdownMenuStyles } from "./DropdownMenu.styles";
import { DropdownMenuItemTestIds } from "./DropdownMenu.utils";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function DropdownMenu(props) {
  const {
    isMobileDevice
  } = useDevice();
  const Component = isMobileDevice ? DropdownMenuMobile : DropdownMenuDesktop;
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props));
}
export function DropdownMenuMobile(props) {
  const {
    target,
    onOpenChange,
    children
  } = props;
  const {
    pushBottomSheetPage,
    popBottomSheetPage
  } = useOverlayContext();
  const clonedTarget = /*#__PURE__*/React.cloneElement(target, {
    onClick: event => {
      pushBottomSheetPage({
        content: /*#__PURE__*/_jsx(MenuList, {
          disablePadding: true,
          children: clonedChildren
        }),
        onClose: () => onOpenChange && onOpenChange(false)
      });
      onOpenChange && onOpenChange(true);
      target.props.onClick && target.props.onClick(event);
    }
  });
  const clonedChildren = React.Children.map(children, child => {
    const rawChild = child;
    if (!rawChild) {
      return rawChild;
    }
    return rawChild.props.closeOnClick ? /*#__PURE__*/React.cloneElement(rawChild, {
      onClick: (event, biContext) => {
        popBottomSheetPage();
        rawChild.props.onClick && rawChild.props.onClick(event, biContext);
      }
    }) : rawChild;
  });
  return clonedTarget;
}
export function DropdownMenuDesktop(props) {
  const {
    target,
    children,
    hAlign = 'right',
    vAlign = 'bottom',
    onOpenChange,
    onClose: _onClose,
    id,
    promotionalAction,
    promotionalActionOnClick
  } = props;
  const overrides = useDropdownMenuStyles({
    minWidth: props.minWidth,
    maxHeight: props.maxHeight,
    maxWidth: props.maxWidth,
    width: props.width
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const menuId = useMemo(() => id || Math.random().toString(), [id]);
  const clonedTarget = /*#__PURE__*/React.cloneElement(target, {
    'aria-owns': anchorEl ? menuId : undefined,
    'aria-haspopup': 'true',
    onClick: event => {
      setAnchorEl(event.currentTarget);
      onOpenChange && onOpenChange(true);
      target.props.onClick && target.props.onClick(event);
    }
  });
  const clonedChildren = React.Children.map(children, child => {
    const rawChild = child;
    if (!rawChild) {
      return rawChild;
    }
    return rawChild.props.closeOnClick ? /*#__PURE__*/React.cloneElement(rawChild, {
      onClick: (event, biContext) => {
        setAnchorEl(null);
        rawChild.props.onClick && rawChild.props.onClick(event, biContext);
      }
    }) : rawChild;
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [clonedTarget, /*#__PURE__*/_jsxs(Menu, {
      classes: {
        paper: overrides.menu
      },
      id: menuId,
      anchorEl: anchorEl,
      open: Boolean(anchorEl),
      autoFocus: false,
      onClose: (event, reason) => {
        _onClose && _onClose(anchorEl, reason, event);
        setAnchorEl(null);
      },
      TransitionProps: {
        onExited() {
          onOpenChange && onOpenChange(false);
        }
      },
      getContentAnchorEl: null,
      transitionDuration: isTestMode ? 0 : 'auto',
      anchorOrigin: {
        vertical: vAlign === 'top' ? -10 : 'bottom',
        horizontal: hAlign
      },
      transformOrigin: {
        vertical: vAlign === 'bottom' ? -10 : 'bottom',
        horizontal: hAlign
      },
      "data-testid": props['data-testid'],
      children: [clonedChildren, promotionalAction && /*#__PURE__*/_jsx(Box, {
        onClick: promotionalActionOnClick,
        className: overrides.promotionalAction,
        children: promotionalAction
      })]
    })]
  });
}
export const DropdownMenuItem = /*#__PURE__*/React.forwardRef(function DropdownMenuItem(props, ref) {
  const {
      children,
      iconStart,
      iconEnd,
      skin = 'secondary',
      as,
      disabled,
      intent,
      tooltipProps,
      closeOnClick,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onClick: _onClick
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const isDisabled = disabledFromIntent || disabled;
  const testid = props['data-testid'];
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: !!(tooltipProps !== null && tooltipProps !== void 0 && tooltipProps.title) || !!tooltipFromIntent,
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({
      "data-testid": DropdownMenuItemTestIds.Tooltip(testid !== null && testid !== void 0 ? testid : '')
    }, tooltipProps || {
      placement: 'top',
      title: tooltipFromIntent
    }), {}, {
      children: isDisabled ? /*#__PURE__*/_jsx("div", {
        "data-testid": DropdownMenuItemTestIds.Wrapper(testid !== null && testid !== void 0 ? testid : ''),
        children: children
      }) : children
    })),
    children: /*#__PURE__*/_jsx(MenuItem, _objectSpread(_objectSpread({}, rest), {}, {
      onClick: (e, biContext) => _onClick === null || _onClick === void 0 ? void 0 : _onClick(e, biContext),
      disabled: isDisabled,
      component: as,
      skin: skin,
      ref: ref,
      children: /*#__PURE__*/_jsxs(Row, {
        gap: 12,
        alignItems: "center",
        children: [iconStart, /*#__PURE__*/_jsx("span", {
          children: children
        }), iconEnd]
      })
    }))
  });
});
DropdownMenuItem.defaultProps = {
  closeOnClick: true
};
DropdownMenu.Item = DropdownMenuItem;